module.exports = __webpack_public_path__ + "logo.png?900190c1f0a7ac93ab02a7b3bed79801";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 322
// module chunks = 0